import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { AppLayout } from '../../AppLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import { appDefaultLanguage, AppLanguage } from '../../model/enums/AppLanguage';
import { appTranslations } from '../index';
import { useAppContext } from '../../state/StateProvider';

const isValidLanguage = (pathname: string): pathname is AppLanguage => {
  return Object.values(AppLanguage).some((appLanguage) => appLanguage === pathname);
};

export const LocalizedRoute = (props: { children: React.ReactNode }) => {
  const [lang, setLang] = useState<AppLanguage>(appDefaultLanguage);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const {
    state: { sourceBranch },
  } = useAppContext();

  useEffect(() => {
    const clearedPath = pathname.replace('/', '');
    if (isValidLanguage(clearedPath)) {
      setLang(clearedPath);
    } else {
      // delete language & keep source in case it is set
      if (sourceBranch !== 'master') {
        navigate(`/?source=${sourceBranch}`);
      } else {
        navigate('/');
      }
    }
  }, [pathname]);

  return (
    <IntlProvider locale={lang} messages={appTranslations[lang]}>
      <AppLayout>{props.children}</AppLayout>
    </IntlProvider>
  );
};
